import React, { createContext, useContext } from "react";

const UnifiedMenuContext = createContext(undefined);

export function UnifiedMenuProvider({ children, activeItemPath }) {
    return (
        <UnifiedMenuContext.Provider value={{ activeItemPath }}>
            {children}
        </UnifiedMenuContext.Provider>
    );
}

export const useUnifiedMenu = () => {
    const context = useContext(UnifiedMenuContext);

    if (!context) {
        throw new Error(
            "useUnifiedMenu must be used within an UnifiedMenuProvider"
        );
    }

    return context;
};
